import { Spinner, Stack } from "@fluentui/react";
import { CustomPanelContentProps } from "../Interfaces/CustomPanel.interfaces";

export const CustomPanelContent = ({ isLoading, children, loadingLabel = "Loading" }: CustomPanelContentProps) => {
  if (isLoading) {
    return (
      <Stack styles={{ root: { alignItems: "center", justifyContent: "center", height: "100%" } }}>
        <Spinner label={loadingLabel} />
      </Stack>
    );
  }

  return <>{children}</>;
};
